
(function($) {
	$.fn.customRange = function(options) {
		var settings = $.extend({}, options);

		return this.each(function() {
            var $input      = $(this);
			var $parent     = $input.parent();
            var disabled    = $(this).prop('disabled');
			var max         = $input.attr('max');
			var min         = $input.attr('min') || 0;
			var textLow     = $input.data('text-low') || '';
			var textHigh    = $input.data('text-high') || '';

			if (!$parent || !$parent.hasClass('custom-range')) {
				$(this).wrap($('<div class="custom-range" />'));
				$parent = $input.parent();

				var $labels = $('<div class="labels" />');
				var $texts = $('<div class="texts" />');

				for (var i = min; i <= max; i++) {
					$('<span />').attr('data-value', i).text(i).appendTo($labels);
				}

				$('<span class="text-low">').text(textLow).appendTo($texts);
				$('<span class="text-high">').text(textHigh).appendTo($texts);

				$labels.prependTo($parent);
				$texts.appendTo($parent);
			}

			$input.on('change input init', function() {
				var value = $(this).val();
				$parent.find('.labels span').removeClass('active').filter('[data-value="' + value + '"]').addClass('active');
			}).trigger('init');

			$parent.find('.labels span').on('click', function() {
				$input.val($(this).data('value')).trigger('change');
			});

            if (disabled) {
                $parent.addClass('disabled');
            } else {
				$parent.removeClass('disabled');
			}
		});
	};
}(jQuery));
